import { Controllers } from "../types/api.types";
import { AppInfo, AppInfoRequest } from "../types/app-info.types";
import { ApiResponse } from "../types/api.types";
import api from "./api";

export const appInfoService = {
  async getAll(): Promise<ApiResponse<AppInfo[]>> {
    const response = await api.get(`${Controllers.APP_INFO}/list`);
    return response.data;
  },

  async getById(id: string): Promise<ApiResponse<AppInfo>> {
    const response = await api.post(`${Controllers.APP_INFO}/get-by-id`, { id });
    return response.data;
  },

  async getByPackageName(id: string): Promise<ApiResponse<AppInfo>> {
    const response = await api.post(`${Controllers.APP_INFO}/bpn`, { id });
    return response.data;
  },

  async create(request: AppInfoRequest): Promise<ApiResponse<AppInfo>> {
    const response = await api.post(`${Controllers.APP_INFO}/create`, request);
    return response.data;
  },

  async update(id: string, request: AppInfoRequest): Promise<ApiResponse<AppInfo>> {
    request.id = id;
    const response = await api.put(`${Controllers.APP_INFO}/update`, request);
    return response.data;
  },

  async delete(id: string): Promise<ApiResponse<string>> {
    const response = await api.post(`${Controllers.APP_INFO}/delete`, { id });
    return response.data;
  },

  async approve(id: string, comment: string): Promise<ApiResponse<AppInfo>> {
    const response = await api.post(
      `${Controllers.APP_INFO}/approve/${id}?comment=${encodeURIComponent(
        comment
      )}`
    );
    return response.data;
  },

  async reject(id: string, comment: string): Promise<ApiResponse<AppInfo>> {
    const response = await api.post(
      `${Controllers.APP_INFO}/reject/${id}?comment=${encodeURIComponent(
        comment
      )}`
    );
    return response.data;
  },

  async bulkUpdate(request: {
    appNames: string[];
    version?: string;
    versionCode?: number;
    downloadLink?: string;
    adminComponentName?: string;
    clientSignatureChecksum?: string;
    firebasePackageName?: string;
  }): Promise<ApiResponse<void>> {
    const response = await api.put(`${Controllers.APP_INFO}/bulk-update`, request);
    return response.data;
  },
};
